var exports = {
  "rN": "activityHeader__V45NcJ",
  "qr": "footer__7ecx1m",
  "NP": "narrowViewportWrapper__C5cNkS",
  "en": "edits__KjKzVq",
  "MN": "HeaderMutedText__fi4I0n",
  "kr": "HeaderLink__tMdYUU",
  "cd": "HeaderMutedTextNoEllipsis__vER2f6",
  "gf": "ActivityHeaderContainer__sf0_ID",
  "rs": "ActivityHeaderGridLayout__Ip6-X-",
  "j0": "AvatarContainer__ybjZo9",
  "rk": "CommentHeaderContentContainer__qvr9Sa",
  "k3": "TitleContainer__9rC_Bh",
  "ts": "AuthorName__V4JPE4",
  "Qi": "AuthorLink__aW5AQQ",
  "R8": "FooterContainer__CesLbt",
  "$I": "ActionsContainer__acCGII",
  "Zk": "EditsContainer__yFuvcF",
  "mG": "BadgesContainer__muaZQX",
  "$S": "BadgesGroupContainer__W96yO7",
  "Cf": "CommentHeaderBadge__8NbBEC",
  "yI": "ActionsButtonsContainer__ZaEPJ0",
  "rj": "containerBase__VGAID6",
  "kj": "containerViewerDidAuthor__etuUDK",
  "YV": "containerMinimized__AWtZ-K",
  "MJ": "containerForceInlineAvatarPadding__S4YfhL",
  "pp": "gridLayoutPaddingBottom__5Q5kJ0",
  "MC": "avatarHiddenOnMedium__tya-Wh",
};

module.exports = exports;
